import React, { useState } from "react";
import axios from "axios";

function ImageUploader(props) {
  const [loading, setLoading] = useState(false);

  const onChangeHandler = (e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    if (props.customPath) data.append("path", props.customPath);
    if (props.customName) data.append("filename", props.customName);
    setLoading(true);
    axios
      .post(`/upload/${props.PortalId}`, data, {})
      .then((res) => {
        console.log(res.data);
        const path = res.data.location;
        props.updateImage(path);
        props.setMessage("");
        setLoading(false);
        console.log("Done uploading!");
      })
      .catch((err) => {
        console.log(err);
        props.setMessage(err.message);
        setLoading(false);
      });
  };

  return (
    <div>
      <div>
        <input type="file" name="file" onChange={onChangeHandler} />
      </div>
      <div
        className="imagepreview"
        style={{
          backgroundColor: "#dcdcdc",
          padding: "10px",
          width: "250px",
        }}
      >
        {loading ? (
          <div className="loader"></div>
        ) : (
          <img
            alt="Preview"
            id="imgPreview"
            src={props.imageSrc}
            style={{ height: "150px", width: "250px" }}
          />
        )}
      </div>
    </div>
  );
}

export default ImageUploader;
